import React from 'react'
import TextCard from '~/components/molecules/TextCard'
import ContactForm from '~/components/organisms/ContactForm'
import FadeInWhenVisible from '~/components/FadeInWhenVisible'


export default function HeroContact({ key, index, isSubmitted, setIsSubmitted, ...props }) {

    const section = props
    return (
        <section id={section?.fieldGroupName ? section.fieldGroupName + (index || '') : 'hero-contact'} className="py-40 pb-44 md:pb-48 bg-sand relative hero-contact-padding">
            <div className="container">
                <div className="grid grid-cols-12 items-center">
                    <div className="col-span-12 md:col-span-5 mb-10 md:mb-12 grid md:grid-cols-5 h-full items-center">
                        <TextCard className="text-center col-span-5 " {...section.textCard} showTrustpilot={true}/>
                  
                    </div>
                    <FadeInWhenVisible className="col-span-12 md:col-span-6 md:col-start-7 -mb-32">
                        <ContactForm className="bg-white border border-[#EFEEEA]" language={props.heroPricing?.language ?? 'en'} isSubmitted={isSubmitted} setIsSubmitted={setIsSubmitted} />
                    </FadeInWhenVisible>
                </div>
            </div>
        </section>
    )
}
